// Mock data for W3Solar website
export const WHATSAPP_NUMBER = "5514991277896"; // Replace with actual WhatsApp number
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}`;

export const heroData = {
  title: "Energia Solar para seu Futuro",
  subtitle: "Economize até 95% na conta de luz com painéis solares de alta qualidade",
  description: "A W3Solar é especialista em soluções de energia solar fotovoltaica para residências e empresas em Avaré e região",
  cta: "Solicitar Orçamento Grátis",
  secondaryCta: "Calcular Economia",
  image: "https://images.unsplash.com/photo-1655300256335-beef51a914fe"
};

export const benefits = [
  {
    id: 1,
    title: "Economia Garantida",
    description: "Reduza sua conta de luz em até 95% e tenha retorno do investimento em 3-5 anos",
    icon: "TrendingDown"
  },
  {
    id: 2,
    title: "Sustentabilidade",
    description: "Contribua para um planeta mais limpo com energia 100% renovável",
    icon: "Leaf"
  },
  {
    id: 3,
    title: "Valorização do Imóvel",
    description: "Imóveis com energia solar valorizam até 30% no mercado",
    icon: "TrendingUp"
  },
  {
    id: 4,
    title: "Instalação Rápida",
    description: "Instalação completa em até 5 dias úteis com nossa equipe especializada",
    icon: "Zap"
  },
  {
    id: 5,
    title: "Garantia Estendida",
    description: "10 anos de garantia nos painéis e 5 anos na instalação",
    icon: "Shield"
  },
  {
    id: 6,
    title: "Financiamento",
    description: "Condições especiais de parcelamento em até 120x",
    icon: "CreditCard"
  }
];

export const services = [
  {
    id: 1,
    title: "Residencial",
    description: "Soluções personalizadas para sua casa com o melhor custo-benefício",
    features: ["Projeto personalizado", "Instalação em até 5 dias", "Monitoramento remoto", "Manutenção inclusa"],
    image: "https://images.unsplash.com/photo-1655300256335-beef51a914fe"
  },
  {
    id: 2,
    title: "Comercial",
    description: "Reduza custos operacionais e aumente a competitividade do seu negócio",
    features: ["Análise de ROI", "Sistemas de grande porte", "Suporte técnico", "Garantia estendida"],
    image: "https://images.pexels.com/photos/6876536/pexels-photo-6876536.jpeg"
  },
  {
    id: 3,
    title: "Industrial",
    description: "Soluções em larga escala para indústrias e grandes empresas",
    features: ["Usinas solares", "Gestão energética", "Consultoria especializada", "Financiamento corporativo"],
    image: "https://images.pexels.com/photos/6876534/pexels-photo-6876534.jpeg"
  }
];

export const projects = [
  {
    id: 1,
    title: "Residência",
    location: "Avaré, São Paulo - SP",
    power: "8.5 kWp",
    economy: "R$ 490/mês",
    image: "https://images.unsplash.com/photo-1655300256335-beef51a914fe",
    description: "Sistema residencial completo com 10 painéis solares"
  },
  {
    id: 2,
    title: "Empresa - Campinas",
    location: "Campinas - SP",
    power: "45 kWp",
    economy: "R$ 4.200/mês",
    image: "https://images.unsplash.com/photo-1668097613572-40b7c11c8727",
    description: "Instalação comercial para redução de custos operacionais"
  },
  {
    id: 3,
    title: "Indústria - Sorocaba",
    location: "Sorocaba - SP",
    power: "120 kWp",
    economy: "R$ 12.500/mês",
    image: "https://images.pexels.com/photos/6876536/pexels-photo-6876536.jpeg",
    description: "Usina solar para grande indústria"
  },
  {
    id: 4,
    title: "Condomínio - Ribeirão Preto",
    location: "Ribeirão Preto - SP",
    power: "35 kWp",
    economy: "R$ 3.100/mês",
    image: "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d",
    description: "Sistema condominial com divisão de créditos"
  },
  {
    id: 5,
    title: "Fazenda - Interior SP",
    location: "Interior de São Paulo",
    power: "65 kWp",
    economy: "R$ 6.800/mês",
    image: "https://images.pexels.com/photos/6876534/pexels-photo-6876534.jpeg",
    description: "Solução rural para agronegócio"
  },
  {
    id: 6,
    title: "Comércio - Santos",
    location: "Santos - SP",
    power: "15 kWp",
    economy: "R$ 1.450/mês",
    image: "https://images.unsplash.com/photo-1724041875334-0a6397111c7e",
    description: "Sistema comercial para shopping center"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Carlos Silva",
    role: "Empresário",
    location: "São Paulo - SP",
    comment: "Instalei o sistema há 2 anos e já recuperei 60% do investimento. A economia na conta de luz é impressionante!",
    rating: 5,
    avatar: "CS"
  },
  {
    id: 2,
    name: "Marina Santos",
    role: "Arquiteta",
    location: "Campinas - SP",
    comment: "Profissionalismo impecável da W3Solar. Instalação rápida e suporte excelente. Super recomendo!",
    rating: 5,
    avatar: "MS"
  },
  {
    id: 3,
    name: "Roberto Almeida",
    role: "Proprietário Industrial",
    location: "Sorocaba - SP",
    comment: "Reduzimos 90% dos custos com energia. O ROI superou nossas expectativas. Melhor investimento que fizemos!",
    rating: 5,
    avatar: "RA"
  }
];

export const faqData = [
  {
    id: 1,
    question: "Quanto tempo leva para instalar um sistema de energia solar?",
    answer: "A instalação residencial típica leva de 1 a 3 dias úteis. Para projetos comerciais e industriais, o prazo varia de 5 a 15 dias, dependendo da complexidade e tamanho do sistema."
  },
  {
    id: 2,
    question: "Qual é o custo médio de um sistema solar residencial?",
    answer: "O investimento varia de R$ 15.000 a R$ 50.000 para residências, dependendo do consumo de energia. Oferecemos financiamento em até 120x e o sistema se paga em 3 a 5 anos através da economia na conta de luz."
  },
  {
    id: 3,
    question: "Os painéis solares funcionam em dias nublados ou chuvosos?",
    answer: "Sim! Os painéis continuam gerando energia mesmo em dias nublados, porém com eficiência reduzida (cerca de 10-25% da capacidade). O sistema é dimensionado considerando essas variações climáticas ao longo do ano."
  },
  {
    id: 4,
    question: "Qual é a vida útil dos painéis solares?",
    answer: "Os painéis solares têm vida útil de 25 a 30 anos, mantendo mais de 80% da eficiência após 25 anos. Os inversores duram de 10 a 15 anos e podem ser substituídos conforme necessário."
  },
  {
    id: 5,
    question: "Preciso fazer manutenção nos painéis?",
    answer: "A manutenção é mínima. Recomendamos limpeza dos painéis 2 vezes ao ano (ou a chuva faz naturalmente) e inspeção anual do sistema. Incluímos 2 manutenções gratuitas no primeiro ano."
  },
  {
    id: 6,
    question: "Como funciona o retorno do investimento?",
    answer: "O ROI médio é de 3 a 5 anos. Após esse período, você terá economia líquida por mais 20-25 anos. Com a economia mensal na conta de luz, o sistema literalmente se paga sozinho."
  },
  {
    id: 7,
    question: "Posso vender o excesso de energia gerada?",
    answer: "No Brasil, adotamos o sistema de compensação de energia (net metering). O excesso vai para a rede da distribuidora e vira créditos que podem ser usados por até 60 meses."
  },
  {
    id: 8,
    question: "Existe financiamento disponível?",
    answer: "Sim! Trabalhamos com diversos bancos e linhas de crédito específicas para energia solar, com condições especiais em até 120 meses e taxas competitivas."
  }
];

export const howItWorks = [
  {
    step: 1,
    title: "Análise e Proposta",
    description: "Analisamos seu consumo e criamos um projeto personalizado com estimativa de economia"
  },
  {
    step: 2,
    title: "Aprovação e Projeto",
    description: "Aprovamos o projeto junto à concessionária e preparamos toda documentação necessária"
  },
  {
    step: 3,
    title: "Instalação",
    description: "Nossa equipe técnica instala o sistema completo em até 3 dias úteis"
  },
  {
    step: 4,
    title: "Homologação",
    description: "Fazemos a homologação junto à distribuidora e você começa a economizar"
  }
];

export const companyInfo = {
  name: "W3Solar",
  email: "contatow3solar@gmail.com",
  phone: "(14) 99127-7896",
  address: "Avaré - SP, Brasil",
  social: {
    facebook: "#",
    instagram: "https://www.instagram.com/w3solarbr",
    linkedin: "#"
  }
};
